import { ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { ColorPicker } from '../colorPicker'
import './styles.scss'
import { hexToRgba, rgbaToHex } from '../colorPicker/utils/convert'
import { usePosition } from '../../hooks/colorPicker/usePosition'

export interface ColorPickerButtonProps {
  id: string
  customSelectColor?: ReactNode
  titleDefaultSelectColor?: string
  disabled?: boolean
  buttonClassName?: string
  color?: string
  onChange?: (key: string, color: string) => void
  onFocus?: (key: string) => void
}

export const ColorPickerButton = ({
  id,
  customSelectColor,
  titleDefaultSelectColor,
  buttonClassName,
  disabled = false,
  color,
  onChange,
  onFocus,
}: ColorPickerButtonProps) => {
  const divRef = useRef<HTMLDivElement>(null)
  const pickerRef = useRef<HTMLDivElement>(null)
  const [showPicker, setShowPicker] = useState(false)
  const { position, calculatePosition } = usePosition(divRef, pickerRef)

  useLayoutEffect(() => {
    if (showPicker) {
      calculatePosition()
    }
  }, [showPicker, calculatePosition])

  // Close the color picker when clicking outside it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        divRef.current &&
        !pickerRef.current.contains(event.target as Node) &&
        !divRef.current.contains(event.target as Node)
      ) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleTogglePicker = () => {
    setShowPicker(!showPicker)
    calculatePosition()
    onFocus?.(id)
  }

  const renderRefContainerSelectColor = () => {
    if (customSelectColor) {
      return (
        <div
          style={{ pointerEvents: disabled ? 'none' : 'auto' }}
          onClick={handleTogglePicker}
          ref={divRef}
        >
          {customSelectColor}
        </div>
      )
    }

    return (
      <div className="container-default" ref={divRef}>
        <button
          disabled={disabled}
          className={`container-btn-default ${buttonClassName}`}
          onClick={handleTogglePicker}
          style={{
            backgroundColor: color,
            cursor: disabled ? 'auto' : 'pointer',
          }}
        ></button>

        {titleDefaultSelectColor && <span>{titleDefaultSelectColor}</span>}
      </div>
    )
  }

  return (
    <>
      {renderRefContainerSelectColor()}

      {showPicker && (
        <div
          className="container-color-picker"
          ref={pickerRef}
          style={{
            top: position.top,
            left: position.left,
          }}
        >
          {/* <X onClick={() => setShowPicker(false)} className="close-container-color-picker" /> */}

          <ColorPicker
            id={id}
            color={hexToRgba(color as string)}
            onChange={(color) => {
              onChange?.(id, rgbaToHex(color))
            }}
          />
        </div>
      )}
    </>
  )
}
